import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRPreferenceBody,
  CRPreferenceBodyAPI,
  CRPreferenceKey,
  CRPreferenceSummary,
  CRPreferenceSummaryAPI,
  PreferencesActions,
  PreferencesState,
} from './types';

type AnyPreference =
  | CRPreferenceKey
  | CRPreferenceSummary
  | CRPreferenceBody
  | undefined;

function sameKeyPreference(a: AnyPreference, b: AnyPreference): boolean {
  return a?.platform === b?.platform && a?.section === b?.section;
}

function getEndpointPreference(key: AnyPreference): string {
  return key ? `/preferences/${key.platform}/${key.section}/` : '/preferences/';
}

function parsePreferenceSummary(
  preferenceSummary: CRPreferenceSummaryAPI,
): CRPreferenceSummary {
  return preferenceSummary;
}

function parsePreferenceBody(
  preferenceDetail: CRPreferenceBodyAPI,
): CRPreferenceBody {
  return preferenceDetail;
}

const preferencesStateSelector = (state: any): PreferencesState =>
  state.preferences;

const preferencesKeySelector = ({
  platform,
  section,
}: CRPreferenceBody | CRPreferenceSummary): CRPreferenceKey => ({
  platform,
  section,
});

function mergePreferenceBody(
  lastBody: CRPreferenceBody,
  currentBody: CRPreferenceBody,
) {
  return currentBody;
}

function combineSummaryBodyPreference(
  summary?: CRPreferenceSummary,
  body?: CRPreferenceBody,
): CRPreferenceSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    platform: merge('platform'),
    section: merge('section'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'preferences',
  getEndpointPreference,
  preferencesStateSelector,
  sameKeyPreference,
  parsePreferenceBody,
  parsePreferenceSummary,
  mergePreferenceBody,
  combineSummaryBodyPreference,
);

const preferencesActions: PreferencesActions = actions;
export * from './types';
export {
  preferencesActions,
  reducer as preferencesReducer,
  watches as preferencesWatches,
  preferencesStateSelector,
  preferencesKeySelector,
};
